import Vue from 'vue'

/*
 * Template layouts
 */
import LayoutEmtpy from '@/Layout/Wrappers/emptyLayout'
import LayoutLogged from '@/Layout/Wrappers/loggedLayout'
import LayoutLogin from '@/Layout/Wrappers/loginLayout'
import LayoutPortal from '@/Layout/Wrappers/portalLayout'
import LayoutRegulacaoDivulgacao from '@/Layout/Wrappers/regulacaoDivulgacaoLayout'

/*
 * Third part components.
 */
import { TabContent } from 'vue-form-wizard'

/*
 * RKM components.
 */
import Alert from '@/components/base/Alert'
import Application from '@/components/base/Application'
import Area from '@/components/base/Area'
import Badge from '@/components/base/Badge'
import Ball from '@/components/base/Ball'
import Button from '@/components/base/Button'
import ButtonGroup from '@/components/base/ButtonGroup'
import Calendar from '@/components/base/Calendar'
import Card from '@/components/base/Card'
import CardBody from '@/components/base/CardBody'
import CardGroup from '@/components/base/CardGroup'
import CardHeader from '@/components/base/CardHeader'
import CardText from '@/components/base/CardText'
import ChartScatter from '@/components/base/ChartScatter'
import Col from '@/components/base/Col'
import Collapse from '@/components/base/Collapse'
import Container from '@/components/base/Container'
import DataTable from '@/components/base/DataTable'
import Dropdown from '@/components/base/Dropdown'
import DropdownDivider from '@/components/base/DropdownDivider'
import DropdownGroup from '@/components/base/DropdownGroup'
import DropdownHeader from '@/components/base/DropdownHeader'
import DropdownItem from '@/components/base/DropdownItem'
import DropdownText from '@/components/base/DropdownText'
import Fab from '@/components/base/Fab'
import FabArea from '@/components/base/FabArea'
import FabItem from '@/components/base/FabItem'
import Form from '@/components/base/Form'
import FormCheckbox from '@/components/base/FormCheckbox'
import FormCheckboxGroup from '@/components/base/FormCheckboxGroup'
import FormDatePicker from '@/components/base/FormDatePicker'
import FormFile from '@/components/base/FormFile'
import FormGroup from '@/components/base/FormGroup'
import FormInput from '@/components/base/FormInput'
import FormInputAutocomplete from '@/components/base/FormInputAutocomplete'
import FormRadio from '@/components/base/FormRadio'
import FormRadioGroup from '@/components/base/FormRadioGroup'
import FormSelect from '@/components/base/FormSelect'
import FormSelectOption from '@/components/base/FormSelectOption'
import FormSelectOptionGroup from '@/components/base/FormSelectOptionGroup'
import FormTextEditor from '@/components/base/FormTextEditor'
import FormTextarea from '@/components/base/FormTextarea'
import FormTextareaIncremental from '@/components/base/FormTextareaIncremental'
import FormTimePicker from '@/components/base/FormTimePicker'
import Icon from '@/components/base/Icon'
import InputGroup from '@/components/base/InputGroup'
import InputGroupAppend from '@/components/base/InputGroupAppend'
import InputGroupPrepend from '@/components/base/InputGroupPrepend'
import InputGroupText from '@/components/base/InputGroupText'
import LayoutBody from '@/components/base/LayoutBody'
import LayoutContent from '@/components/base/LayoutContent'
import LayoutRouter from '@/components/base/LayoutRouter'
import List from '@/components/base/List'
import ListGroup from '@/components/base/ListGroup'
import ListGroupItem from '@/components/base/ListGroupItem'
import Main from '@/components/base/Main'
import Map from '@/components/base/Map'
import MapMarker from '@/components/base/MapMarker'
import MapTileLayer from '@/components/base/MapTileLayer'
import MapTooltip from '@/components/base/MapTooltip'
import Modal from '@/components/base/Modal'
import NavItem from '@/components/base/NavItem'
import NavItemDropdown from '@/components/base/NavItemDropdown'
import Navbar from '@/components/base/Navbar'
import NavbarBrand from '@/components/base/NavbarBrand'
import NavbarNav from '@/components/base/NavbarNav'
import NavbarNavIcon from '@/components/base/NavbarNavIcon'
import NavbarNavNotificationButton from '@/components/base/NavbarNavNotificationButton'
import NavbarNavReleaseNotesButton from '@/components/base/NavbarNavReleaseNotesButton'
import Notification from '@/components/base/Notification'
import Overlay from '@/components/base/Overlay'
import Popover from '@/components/base/Popover'
import RkmFormMultiselect from '@/components/base/FormMultiselect'
import Row from '@/components/base/Row'
import Sidebar from '@/components/base/Sidebar'
import SidebarList from '@/components/base/SidebarList'
import SidebarListGroup from '@/components/base/SidebarListGroup'
import SidebarListGroupItem from '@/components/base/SidebarListGroupItem'
import Tab from '@/components/base/Tab'
import Table from '@/components/base/Table'
import Tabs from '@/components/base/Tabs'
import Td from '@/components/base/Td'
import Th from '@/components/base/Th'
import Timeline from '@/components/base/Timeline'
import TimelineItem from '@/components/base/TimelineItem'
import Toast from '@/components/base/Toast'
import Tooltip from '@/components/base/Tooltip'
import Tr from '@/components/base/Tr'
import Wizard from '@/components/base/Wizard'

/*
 * Template layouts
 */
Vue.component('empty-layout', LayoutEmtpy)
Vue.component('logged-layout', LayoutLogged)
Vue.component('login-layout', LayoutLogin)
Vue.component('portal-layout', LayoutPortal)
Vue.component('regulacao-divulgacao-layout', LayoutRegulacaoDivulgacao)

/*
 * RKM components.
 */
Vue.component('RkmAlert', Alert)
Vue.component('RkmApplication', Application)
Vue.component('RkmArea', Area)
Vue.component('RkmBadge', Badge)
Vue.component('RkmBall', Ball)
Vue.component('RkmButton', Button)
Vue.component('RkmButtonGroup', ButtonGroup)
Vue.component('RkmCalendar', Calendar)
Vue.component('RkmCard', Card)
Vue.component('RkmCardGroup', CardGroup)
Vue.component('RkmCardText', CardText)
Vue.component('RkmChartScatter', ChartScatter)
Vue.component('RkmCol', Col)
Vue.component('RkmCollapse', Collapse)
Vue.component('RkmContainer', Container)
Vue.component('RkmDataTable', DataTable)
Vue.component('RkmDropdown', Dropdown)
Vue.component('RkmDropdownGroup', DropdownGroup)
Vue.component('RkmDropdownHeader', DropdownHeader)
Vue.component('RkmDropdownItem', DropdownItem)
Vue.component('RkmDropdownText', DropdownText)
Vue.component('RkmFab', Fab)
Vue.component('RkmFabArea', FabArea)
Vue.component('RkmFabItem', FabItem)
Vue.component('RkmForm', Form)
Vue.component('RkmFormCheckbox', FormCheckbox)
Vue.component('RkmFormCheckboxGroup', FormCheckboxGroup)
Vue.component('RkmFormDatePicker', FormDatePicker)
Vue.component('RkmFormFile', FormFile)
Vue.component('RkmFormGroup', FormGroup)
Vue.component('RkmFormInput', FormInput)
Vue.component('RkmFormInputAutocomplete', FormInputAutocomplete)
Vue.component('RkmFormMultiselect', RkmFormMultiselect )
Vue.component('RkmFormRadio', FormRadio)
Vue.component('RkmFormRadioGroup', FormRadioGroup)
Vue.component('RkmFormSelect', FormSelect)
Vue.component('RkmFormSelectOption', FormSelectOption)
Vue.component('RkmFormSelectOptionGroup', FormSelectOptionGroup)
Vue.component('RkmFormTextarea', FormTextarea)
Vue.component('RkmFormTextareaIncremental', FormTextareaIncremental)
Vue.component('RkmFormTimePicker', FormTimePicker)
Vue.component('RkmIcon', Icon)
Vue.component('RkmInputGroup', InputGroup)
Vue.component('RkmInputGroupAppend', InputGroupAppend)
Vue.component('RkmInputGroupPrepend', InputGroupPrepend)
Vue.component('RkmInputGroupText', InputGroupText)
Vue.component('RkmLayoutBody', LayoutBody)
Vue.component('RkmLayoutContent', LayoutContent)
Vue.component('RkmLayoutRouter', LayoutRouter)
Vue.component('RkmList', List)
Vue.component('RkmListGroup', ListGroup)
Vue.component('RkmListGroupItem', ListGroupItem)
Vue.component('RkmMain', Main)
Vue.component('RkmMap', Map)
Vue.component('RkmMapTooltip', MapTooltip)
Vue.component('RkmModal', Modal)
Vue.component('RkmNavItem', NavItem)
Vue.component('RkmNavItemDropdown', NavItemDropdown)
Vue.component('RkmNavbar', Navbar)
Vue.component('RkmNavbarBrand', NavbarBrand)
Vue.component('RkmNavbarNav', NavbarNav)
Vue.component('RkmNavbarNavIcon', NavbarNavIcon)
Vue.component('RkmNavbarNavNotificationButton', NavbarNavNotificationButton)
Vue.component('RkmNavbarNavReleaseNotesButton', NavbarNavReleaseNotesButton)
Vue.component('RkmNotification', Notification)
Vue.component('RkmOverlay', Overlay)
Vue.component('RkmPopover', Popover)
Vue.component('RkmRow', Row)
Vue.component('RkmTab', Tab)
Vue.component('RkmTable', Table)
Vue.component('RkmTabs', Tabs)
Vue.component('RkmTd', Td)
Vue.component('RkmTh', Th)
Vue.component('RkmTimeline', Timeline)
Vue.component('RkmTimelineItem', TimelineItem)
Vue.component('RkmToast', Toast)
Vue.component('RkmTooltip', Tooltip)
Vue.component('RkmTr', Tr)
Vue.component('RkmWizard', Wizard)
Vue.component('RkmWizardTab', TabContent)
Vue.component(`RkmCardBody`, CardBody)
Vue.component(`RkmCardHeader`, CardHeader)
Vue.component(`RkmDropdownDivider`, DropdownDivider)
Vue.component(`RkmMapMarker`, MapMarker)
Vue.component(`RkmMapTileLayer`, MapTileLayer)
Vue.component(`RkmSidebarListGroupItem`, SidebarListGroupItem)
Vue.component(`RkmSidebarListGroup`, SidebarListGroup)
Vue.component(`RkmSidebarList`, SidebarList)
Vue.component(`RkmSidebar`, Sidebar)
Vue.component(`RkmTextEditor`, FormTextEditor)